<div class="min-h-full bg-[#fafaf7] font-sans">

  @if (isLoading()) {
    <div class="flex items-center justify-center min-h-[60vh]">
      <div class="relative w-10 h-10">
        <div class="absolute inset-0 rounded-full border-4 border-stone-200"></div>
        <div class="absolute inset-0 rounded-full border-4 border-t-primary-400 animate-spin"></div>
      </div>
    </div>
  }

  @if (!isLoading() && communique()) {
    <!-- Top bar -->
    <div class="max-w-[1200px] mx-auto px-5 sm:px-8 pt-8 pb-4">
      <div class="fiche-titlebar grid grid-cols-3 items-center">

        <!-- Back -->
        <div class="justify-self-start">
          <button (click)="goBack()" class="flex items-center gap-2 text-stone-400 hover:text-primary-600 transition-colors cursor-pointer">
            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/>
            </svg>
            <span class="text-[11px] font-bold uppercase tracking-wider">Retour aux communiqués</span>
          </button>
        </div>

        <!-- Title -->
        <div class="justify-self-center">
          <h1 class="text-lg font-semibold text-stone-800">Communiqué</h1>
        </div>

        <!-- Actions -->
        <div class="justify-self-end flex items-center gap-2">
          @if ((communique()!.status || 'ACTI') !== 'ACTI') {
            <button (click)="confirmStatus('ACTI')" [disabled]="isSaving()"
              class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium border border-emerald-200 text-emerald-700 bg-emerald-50 hover:bg-emerald-100 rounded-lg transition-colors disabled:opacity-50">
              <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
              Publier
            </button>
          }
          @if ((communique()!.status || 'ACTI') === 'ACTI') {
            <button (click)="confirmStatus('INAC')" [disabled]="isSaving()"
              class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium border border-amber-200 text-amber-700 bg-amber-50 hover:bg-amber-100 rounded-lg transition-colors disabled:opacity-50">
              <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"/></svg>
              Désactiver
            </button>
          }
          <button (click)="onEdit()" [disabled]="isSaving()"
            class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium border border-stone-200 text-stone-600 bg-white hover:bg-stone-50 rounded-lg transition-colors disabled:opacity-50">
            <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931z"/>
            </svg>
            Modifier
          </button>
          <button (click)="confirmDelete()" [disabled]="isSaving()"
            class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium border border-red-200 text-red-600 bg-white hover:bg-red-50 rounded-lg transition-colors disabled:opacity-50">
            <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"/>
            </svg>
            Supprimer
          </button>
        </div>

      </div>
    </div>

    <div class="max-w-[1200px] mx-auto px-5 sm:px-8 pb-8 space-y-4">

      @if (errorMessage()) {
        <div class="p-3 rounded-xl bg-red-50 border border-red-100 text-sm text-red-700 flex items-center gap-2">
          <span class="material-icons text-base text-red-500">error_outline</span>
          {{ errorMessage() }}
        </div>
      }

      <!-- Meta card -->
      <div class="bg-white rounded-2xl border border-stone-100 shadow-sm px-6 py-5 flex flex-wrap items-start gap-6">
        <div class="flex-1 min-w-0">
          <p autoDir class="text-base font-semibold text-stone-800 leading-snug">{{ communique()!.title_ln1 }}</p>
          @if (communique()!.reference) {
            <p class="text-xs text-stone-400 mt-1">Réf. {{ communique()!.reference }}</p>
          }
        </div>
        <div class="flex items-center gap-4 flex-shrink-0">
          <div class="text-right">
            <p class="text-xs text-stone-400">Date de publication</p>
            <p class="text-sm font-medium text-stone-700 font-mono">
              {{ communique()!.publish_date ? (communique()!.publish_date | date:'dd/MM/yyyy') : '—' }}
            </p>
          </div>
          <span class="inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full border"
            [class]="statusBadgeClass(communique()!.status || 'ACTI')">
            <span class="w-1.5 h-1.5 rounded-full flex-shrink-0"
              [class]="(communique()!.status || 'ACTI') === 'ACTI' ? 'bg-emerald-500' : (communique()!.status || 'ACTI') === 'ARCH' ? 'bg-stone-400' : 'bg-amber-400'">
            </span>
            {{ communique()!.status_label || statusLabel(communique()!.status || 'ACTI') }}
          </span>
          <app-tag-chips [value]="communique()!.press_tags" [max]="999"></app-tag-chips>
        </div>
      </div>

      <!-- Document preview -->
      @if (communique()!.pdf_link) {
        <div class="bg-white rounded-2xl border border-stone-100 shadow-sm overflow-hidden">
          <div class="px-5 py-3 border-b border-stone-100 flex items-center justify-between">
            <div class="flex items-center gap-2">
              <span class="material-icons text-stone-400 text-base">description</span>
              <span class="text-xs font-medium text-stone-600">{{ communique()!.pdf_name || 'Document' }}</span>
            </div>
            <a [href]="communique()!.pdf_link" target="_blank" download
              class="inline-flex items-center gap-1.5 text-xs text-primary-600 hover:text-primary-800 font-medium transition-colors">
              <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"/>
              </svg>
              Télécharger
            </a>
          </div>

          @if (fileExt() === 'pdf') {
            <iframe [src]="safePdfUrl()!" class="w-full border-0 block"
                    style="height: calc(100vh - 280px);" title="Aperçu PDF"></iframe>
          } @else if (['jpg','jpeg','png','gif','webp'].includes(fileExt())) {
            <div class="flex justify-center items-center p-6">
              <img [src]="communique()!.pdf_link" [alt]="communique()!.pdf_name || 'Document'"
                class="max-w-full object-contain rounded-lg shadow" style="max-height: calc(100vh - 320px);" />
            </div>
          } @else {
            <div class="flex flex-col items-center justify-center py-16 gap-4">
              <span class="material-icons text-5xl text-stone-200">description</span>
              <p class="text-stone-500 text-sm">Aperçu non disponible pour ce format.</p>
              <a [href]="communique()!.pdf_link" target="_blank"
                class="inline-flex items-center gap-2 px-4 py-2 bg-primary-600 text-white text-sm font-medium rounded-xl hover:bg-primary-700 transition-colors">
                <span class="material-icons text-base">open_in_new</span>
                Ouvrir le fichier
              </a>
            </div>
          }
        </div>
      } @else {
        <div class="bg-white rounded-2xl border border-stone-100 shadow-sm flex flex-col items-center justify-center py-16 gap-3">
          <span class="material-icons text-4xl text-stone-200">description</span>
          <p class="text-stone-400 text-sm">Aucun document joint à ce communiqué.</p>
        </div>
      }

    </div>
  }

  @if (!isLoading() && !communique()) {
    <div class="flex flex-col items-center justify-center min-h-[60vh] gap-4">
      <span class="material-icons text-5xl text-stone-200">search_off</span>
      <p class="text-stone-500 text-sm">Communiqué introuvable.</p>
      <button (click)="goBack()" class="text-primary-600 hover:underline text-sm">Retour à la liste</button>
    </div>
  }
</div>

<!-- Status confirm modal -->
@if (pendingStatus()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
    <div class="bg-white rounded-3xl shadow-xl border border-stone-100 p-6 w-full max-w-sm mx-4">
      <div class="flex items-center gap-3 mb-4">
        <div class="w-10 h-10 rounded-2xl flex items-center justify-center flex-shrink-0"
          [class]="pendingStatus()!.status === 'INAC' ? 'bg-amber-50' : 'bg-emerald-50'">
          <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
            [class]="pendingStatus()!.status === 'INAC' ? 'text-amber-500' : 'text-emerald-500'">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
        </div>
        <div>
          <p class="font-semibold text-stone-800 text-sm">Confirmer le changement</p>
          <p class="text-xs text-stone-500 mt-0.5">
            @if (pendingStatus()!.status === 'INAC') { Ce communiqué sera masqué du site public. }
            @else { Ce communiqué sera visible sur le site public. }
          </p>
        </div>
      </div>
      <div class="flex gap-2 justify-end">
        <button type="button" (click)="cancelStatus()"
          class="px-4 py-2 text-sm font-medium text-stone-600 border border-stone-200 rounded-xl hover:bg-stone-50 transition-colors">
          Annuler
        </button>
        <button type="button" (click)="applyStatus()"
          class="px-4 py-2 text-sm font-medium text-white rounded-xl transition-colors"
          [class]="pendingStatus()!.status === 'INAC' ? 'bg-amber-500 hover:bg-amber-600' : 'bg-emerald-600 hover:bg-emerald-700'">
          {{ pendingStatusLabel(pendingStatus()!.status) }}
        </button>
      </div>
    </div>
  </div>
}

<!-- Delete confirm modal -->
@if (pendingDelete()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
    <div class="bg-white rounded-3xl shadow-xl border border-stone-100 p-6 w-full max-w-sm mx-4">
      <div class="flex items-center gap-3 mb-4">
        <div class="w-10 h-10 rounded-2xl bg-red-50 flex items-center justify-center flex-shrink-0">
          <svg class="w-5 h-5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"/>
          </svg>
        </div>
        <div>
          <p class="font-semibold text-stone-800 text-sm">Supprimer ce communiqué</p>
          <p class="text-xs text-stone-500 mt-0.5">Cette action est irréversible.</p>
        </div>
      </div>
      <div class="flex gap-2 justify-end">
        <button type="button" (click)="cancelDelete()"
          class="px-4 py-2 text-sm font-medium text-stone-600 border border-stone-200 rounded-xl hover:bg-stone-50 transition-colors">
          Annuler
        </button>
        <button type="button" (click)="applyDelete()"
          class="px-4 py-2 text-sm font-medium text-white bg-red-500 hover:bg-red-600 rounded-xl transition-colors">
          Supprimer
        </button>
      </div>
    </div>
  </div>
}
